module.exports = __webpack_public_path__ + "assets/img/4c994061240cf9b217d1ccb4bd9c0937.svg";